import React from "react";
import { methodSteps } from "../data/content";
export function Method() {
  return <section id="methode" className="bg-white py-24 lg:py-32" data-id="element-129" data-mp="72lrh1w6r2rj">
      <div className="mx-auto max-w-7xl px-6 sm:px-8" data-id="element-130" data-mp="74yis5nu2ph9">
        <div className="max-w-2xl" data-id="element-131" data-mp="c1otedgvcsva">
          <p className="text-[15px] font-medium text-muted" data-id="element-132" data-mp="c2rjwkaa4tao">Méthode</p>
          <h2 className="mt-4 font-display text-4xl font-semibold leading-[1.1] tracking-tight text-ink sm:text-5xl" data-id="element-133" data-mp="h0038o75z3di">
            Quatre étapes pour passer de l'enjeu à l'influence.
          </h2>
        </div>

        <ol className="relative mt-16 grid gap-10 md:grid-cols-2 lg:grid-cols-4 lg:gap-8" data-id="element-134" data-mp="3kibblevay3nm">
          <span className="absolute left-0 right-0 top-5 hidden h-px bg-line lg:block" aria-hidden="true" data-id="element-135" data-mp="3pg34ab3rttsv" />
          {methodSteps.map((s, i) => <li key={s.title} className="relative" data-id="element-136" data-mp="2ws7775aahzvk" data-mpi={i}>
              <span className="relative flex h-10 w-10 items-center justify-center rounded-full bg-ink font-display text-sm font-semibold text-white" data-id="element-137" data-mp="2wre7go9r0amx">
                {i + 1}
              </span>
              <h3 className="mt-6 font-display text-2xl font-semibold text-ink" data-id="element-138" data-mp="pe3eg4wfxlhb">{s.title}</h3>
              <p className="mt-3 text-[15px] leading-relaxed text-muted" data-id="element-139" data-mp="khmp57di912n">{s.text}</p>
            </li>)}
        </ol>
      </div>
    </section>;
}